import { IPage, ISearchPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";

//详情
export interface ITiredSettingDetail {
    id?: string,
    prefix?: string,
    shopId?: string,
    shopCode?: string,
    shopName?: string,
    branch?: string,
    ver?: string,
    enable?: string,
    orgCode?: string,
    orgName?: string,
    contact?: string,
    phone?: string,
    address?: string,
    status?: number | boolean,
    sourceApp?: string,
    categoryName?:string,
    typeCode?:string,
    typeName?:string,
    suffixNum?: number,
    settingType? : string,
    isYear?: number,
    isMonth?: number,
    isDate?: number,
    style? : string,
    note? : string,
    orderNum?: number,
    traceId?: string,
    deleteFlag?: number,
    createTime? : string,
    updateTime? : string,
    createUser? : string,
    updateUser? : string,
    [key: string]: any
}
//新增
export interface ITiredSettingInsert {
    "prefix"?:string,   // "ad reprehenderit magna in",
    "suffixNum"?:number,   // 22,
    "settingType"?:string,   // "CALCULATE",
    "isYear"?:number,   // 55,
    "isMonth"?:number,   // 59,
    "isDate"?:number,   // 20180911,
    "note"?:string,   // "veniam sint laborum tempor",
    "style"?:string,   // "incididunt"
}

//编辑
export interface ITiredSettingUpdate extends ITiredSettingInsert {
    id?: string,
}
//搜索条件
export interface ITiredSettingSearchFields {
    startTime?:string
    endTime?:string
    [key:string]:any
}

export interface ITiredSettingSearch
    extends ITiredSettingSearchFields, ISearchPage {
    shopId?: string
    shopCode?: string
}

export interface IpositionSearch
    extends ITiredSettingSearchFields, ISearchPage {
}



class TiredSettingService {
    async page(searchVo: ITiredSettingSearch, config: object = {}) {
        const apiUrl = "/threeInspection/auth/list";
        return await httpRequest.post<IPage<ITiredSettingDetail>>(apiUrl, searchVo, config);
    }      
    async insert(searchVo: ITiredSettingSearchFields) {
        const apiUrl = "/threeInspection/auth/insert";
        return await httpRequest.post<any>(apiUrl, searchVo);
    }    
    async edit(searchVo: ITiredSettingSearchFields) {
        const apiUrl = "/threeInspection/auth/update";
        return await httpRequest.post<any>(apiUrl, searchVo);
    }   
    async onDelete(searchVo: ITiredSettingSearchFields) {
        const apiUrl = "/threeInspection/auth/delete";
        return await httpRequest.post<any>(apiUrl, searchVo);
    } 
    async one(searchVo: ITiredSettingSearchFields) {
        const apiUrl = "/threeInspection/ciOrder/page";
        return await httpRequest.post<IPage<ITiredSettingDetail>>(apiUrl, searchVo);
    }    
    async orderLogs(searchVo: ITiredSettingSearchFields) {
        const apiUrl = "/threeInspection/ciOrder/progress_log/list";
        return await httpRequest.post<any>(apiUrl, searchVo);
    }   
    async getTiredSettingImg(updateVo: ITiredSettingUpdate) {
        const apiUrl = "/threeInspection/ciOrder/list_for_group";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    async getImageClassifyList(updateVo: ITiredSettingUpdate) {
        const apiUrl = "/threeInspection/ciOrder/list_for_group";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    async getTotal(shopCode: any) {
        const apiUrl = `/threeInspection/ciOrder/accountStatic/${shopCode}`
        return await httpRequest.get<any>(apiUrl)
    }
    //导出
    async export(searchVo: any) {
        const appPageUrl = '/threeInspection/ciOrder/pageDetails/export'
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 })
    }
    async update(searchVo: ITiredSettingSearchFields) {
        const apiUrl = "/threeInspection/auth/fatigue/update";
        return await httpRequest.post<any>(apiUrl, searchVo);
    }   
}

export const tiredSettingService = new TiredSettingService();
